export default __webpack_public_path__ + "static/media/013-flowers.a3bd6290.svg";